import styled from 'styled-components';

export const Base = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	margin-bottom: 8px;
`;

export const Label = styled.label`
	font-size: 12px;
	font-weight: 500;
	text-transform: uppercase;
	letter-spacing: 0.04em;
	color: ${({ theme }) => theme.gray[700]};
`;

// fades the message label + MultilineInput when notify is unchecked
export const MessageGroup = styled.div<{ $disabled: boolean }>`
	display: flex;
	flex-direction: column;
	gap: 6px;
	transition: opacity 0.15s ease;
	opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
`;

export const NotifyRow = styled.div`
	display: flex;
	align-items: center;
	font-size: 13px;
	color: ${({ theme }) => theme.gray[1000]};
	user-select: none;
`;
